type GlobalWithBasePath = typeof globalThis & { __BASE_PATH__?: unknown };

declare const __BASE_PATH__: string | undefined;

declare global {
  // ensure ambient declaration for SSR global injection scenarios
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Global {
    __BASE_PATH__?: unknown;
  }
}

const normalizeBasePath = (raw: unknown): string => {
  if (typeof raw !== 'string') {
    return '/';
  }

  const trimmed = raw.trim();
  if (trimmed.length === 0) {
    return '/';
  }

  const withoutLeadingSlashes = trimmed.replace(/^\/+/u, '');
  if (withoutLeadingSlashes.length === 0) {
    return '/';
  }

  const withoutTrailingSlashes = withoutLeadingSlashes.replace(/\/+$/u, '');
  if (withoutTrailingSlashes.length === 0) {
    return '/';
  }

  return `/${withoutTrailingSlashes}`;
};

const readBasePath = (): unknown => {
  try {
    if (typeof __BASE_PATH__ !== 'undefined') {
      return __BASE_PATH__;
    }
  } catch (error) {
    // noop when define replacement isn't available
  }

  if (typeof globalThis === 'undefined') {
    return '/';
  }

  return (globalThis as GlobalWithBasePath).__BASE_PATH__;
};

export const resolveBasePath = (): string => {
  return normalizeBasePath(readBasePath());
};
